import { current } from './Transaction.js';
export const UNKNOWN = Object.create(null);
/**
 * An abstract observable class that manages its subscriptions.
 * Requires the value to be queriable synchronously at any time (see abstract `get` method).
 * Holder is based on it, as are a few of the intermediate types returned by various operators.
 */
export class Subscribable {
    constructor() {
        this.callbacks = new Set();
    }
    changed() {
        if (!this.callbacks.size) {
            return;
        }
        const newValue = this.get();
        if (newValue === UNKNOWN) {
            return;
        }
        current().enqueue(this, newValue, this.callbacks);
    }
    subscriptionsWillChange(_hasSubscriptions) {
        // Empty default implementation
    }
    subscribe(cb) {
        if (this.callbacks.has(cb)) {
            return;
        }
        if (this.callbacks.size === 0) {
            this.subscriptionsWillChange(true);
        }
        this.callbacks.add(cb);
        const value = this.get();
        if (value !== UNKNOWN) {
            cb(value, this);
        }
    }
    unsubscribe(cb) {
        if (this.callbacks.has(cb) && this.callbacks.size === 1) {
            this.subscriptionsWillChange(false);
        }
        this.callbacks.delete(cb);
    }
}
